import { render, staticRenderFns } from "./ResultFreeTicket.vue?vue&type=template&id=87aca432&"
import script from "./ResultFreeTicket.vue?vue&type=script&lang=ts&"
export * from "./ResultFreeTicket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
